import { storeToRefs } from 'pinia'
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useApi } from '@/features/api/useAPI'
import EventsPlanner from '@/features/app/components/EventsPlanner.vue'
import Login from '@/features/login/Login.vue'
import Preload from '@/features/preload/Preload.vue'
import { useTelemetry } from '@/features/telemetry/useTelemetry'
import { useUserStore } from '@/features/user/useUserStore'
import { type Nullable } from '@/types'

const { DEV } = import.meta.env

export const PATH = {
	ROOT: '/',
	LOGIN: '/login',
	PLANNER: '/planner'
}

const routes: RouteRecordRaw[] = [
	{ path: PATH.ROOT, component: Preload },
	{ path: PATH.LOGIN, component: Login },
	{ path: PATH.PLANNER, component: EventsPlanner }
]

export const router = createRouter({
	history: createWebHistory(),
	routes
})

router.beforeEach(async (to, _from) => {
	const { isUserInitialized } = storeToRefs(useUserStore())
	const { updateAppVersionHeader } = useApi()
	const { trackEvent } = useTelemetry()

	const isSecuredRoute = ![PATH.ROOT, PATH.LOGIN].includes(to.path)

	if (!isUserInitialized.value) {
		updateAppVersionHeader(to.query['app-version'] as Nullable<string>)

		if (isSecuredRoute) {
			if (DEV) {
				trackEvent('app', 'Redirect to root page - dev development', {
					isUserInitialized: isUserInitialized.value,
					isSecuredRoute,
					to: JSON.stringify(to)
				})

				// when user is not initialized and wants in DEV see subpage we can move him to root since preload will handle internal token mechanism
				return { path: PATH.ROOT }
			}

			trackEvent('app', 'Redirect to Login page', { isUserInitialized: isUserInitialized.value, isSecuredRoute, to: JSON.stringify(to) })

			// when user is not initialized and wants to see subpage - block it and move him/her to login page for jwt
			return { path: PATH.LOGIN }
		}

		// TODO: remove after investigation
		trackEvent('app', 'Not secured - pass through', { to: JSON.stringify(to) })

		return true
	} else {
		// TODO: remove after investigation
		trackEvent('app', 'User not initialized - pass through', { to: JSON.stringify(to) })

		return true
	}
})
